var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 9.13282V18.25C18.875 18.4158 18.8092 18.5747 18.6919 18.6919C18.5747 18.8092 18.4158 18.875 18.25 18.875H5.75C5.58424 18.875 5.42527 18.8092 5.30806 18.6919C5.19085 18.5747 5.125 18.4158 5.125 18.25L5.125 5.75C5.125 5.58424 5.19085 5.42527 5.30806 5.30806C5.42527 5.19085 5.58424 5.125 5.75 5.125L14.8672 5.125C14.9483 5.12472 15.0288 5.14044 15.1038 5.17128C15.1789 5.20211 15.2472 5.24745 15.3047 5.30469L18.6953 8.69532C18.7526 8.75284 18.7979 8.8211 18.8287 8.89617C18.8596 8.97124 18.8753 9.05166 18.875 9.13282V9.13282Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18.875L8.25 13.875C8.25 13.7092 8.31585 13.5503 8.43306 13.4331C8.55027 13.3158 8.70924 13.25 8.875 13.25L15.125 13.25C15.2908 13.25 15.4497 13.3158 15.5669 13.4331C15.6842 13.5503 15.75 13.7092 15.75 13.875V18.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 7.625L9.5 7.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.3d719771947833738856d1cafc188e4e.svg";
export { ForwardRef as ReactComponent };